import { providerApi } from '@/api/ProviderApi'
import { useMutation } from '@tanstack/react-query'

const useReschedulePatientAppointment = () => {
	return useMutation({
		mutationFn: ({ appointmentId }: { appointmentId: number }) =>
			providerApi.rescheduleAppointment(appointmentId),
	})
}

export { useReschedulePatientAppointment }
